import { useSelector } from 'react-redux'

import { Colors } from '~/styles'
import { GenerateFilterTerm } from '~/utils'
import {
  Card,
  Alerts,
  Loading,
  ModalDel,
  MasterGrid,
} from '~/components'

import Styled from './vessel-forecast.styled'
import useHooks from './vessel-forecast.hooks'
import GridColumn from './vessel-forecast.column.json'
import { ManageModal, GenerateServiceRequestModal } from './components'

import { DropdownLocSide } from '../dashboard/dashboard-dropdown.container'

const VesselForecast = () => {
  const { data, methods } = useHooks()

  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  return (
    <Styled.Main>
      {data.openManageModal && (
        <ManageModal
          dataItem={data.dataItem}
          actionType={data.actionType}
          showModal={data.openManageModal}
          handleClose={methods.toggleManageModal}
          refetchData={() => {
            methods.fetchData({
              ...data.dataState,
              status: data.selectedFilter?.value,
              filterString: GenerateFilterTerm(data.dataState.filter, GridColumn),
            })
          }}
        />
      )}

      {data.openDeleteModal && (
        <ModalDel
          deleteText='Are you sure to delete the data ?'
          submitDelete={methods.deleteVesselForecast}
          toggleDialog={methods.toggleDeleteModal}
        />
      )}

      {data.openCreateSRModal && (
        <GenerateServiceRequestModal
          isOpen={data.openCreateSRModal}
          dataItem={data.dataItem}
          whiteheader={false}
          toggleAlert={methods.handleToggleAlert}
          toggleModal={() => {
            methods.toggleCreateSRModal()
            methods.fetchData({
              ...data.dataState,
              status: data.selectedFilter?.value,
              filterString: GenerateFilterTerm(data.dataState.filter, GridColumn),
            })
          }}
        />
      )}

      <Card>
        <Styled.HeaderVesselForecast>
          <Styled.Title id='vessel_forecast_title'>VESSEL FORECAST</Styled.Title>

          <Styled.ActionWrapper>
            <Styled.DropdownContainer>
              <DropdownLocSide
                location={Location}
                dataList={UserLocations}
                setLocation={methods._setLocation}
              />
            </Styled.DropdownContainer>
            <Styled.ButtonAdd
              id='vessel_forecast_button_add'
              color='green'
              onClick={() => methods.handleClickAction(undefined, 'create')}
            >
              ADD NEW DATA
            </Styled.ButtonAdd>
          </Styled.ActionWrapper>
        </Styled.HeaderVesselForecast>

        <Styled.VesselForecastFilter>
          {data.filterCounts.map((item, index) => (
            <Styled.FilterItem
              key={index}
              onClick={() => methods.handleFilterClick(item)}
              style={{
                cursor: 'pointer',
                color: data.selectedFilter?.value === item.value ? Colors.softBlue : Colors.modalGrey,
              }}
            >
              {`${item.label} (${item.count})`}
            </Styled.FilterItem>
          ))}
        </Styled.VesselForecastFilter>

        {!data.gridColumnLoading ? (
          <Styled.GridContainer>
            <MasterGrid
              id='m_vessel_forecast_grid'
              actionLocked
              pending={data.pending}
              height={data.heightGrid - 92}
              data={data.dataGrid}
              total={data.dataCount}
              dataState={data.dataState}
              reorderable={true}
              gridColumn={
                !data.pathRole.allowEdit && !data.pathRole.allowDelete
                  ? data.gridColumnActive.filter((e) => e.field.toLowerCase() !== 'action')
                  : data.gridColumnActive
              }
              pageSizes={[20, 50, 100]}
              codeCell={methods._codeCell}
              actionCell={methods._actionCell}
              customCell={methods._statusCell}
              allFastCell={methods._allFastCell}
              overlapCell={methods._overlapCell}
              onPageChange={methods.onPageChange}
              onDataStateChange={methods.onDataStateChange}
            />
            <Styled.LegendContainer>
              {data.legendTable.map((item, index) => (
                <Styled.LegendItem key={index}>
                  <Styled.LegendColor color={item.color} />
                  <Styled.LegendLabel>{item.label}</Styled.LegendLabel>
                </Styled.LegendItem>
              ))}
            </Styled.LegendContainer>
          </Styled.GridContainer>
        ) : (
          <Styled.LoadingContainer style={{ height: '75vh', alignItems: 'center' }}>
            <Loading id='vessel-forecast-grid-loading-indicator' />
          </Styled.LoadingContainer>
        )}
      </Card>

      {data.alert.visible && (
        <Alerts
          {...data.alert}
          open={data.alert}
          close={methods._onClose}
        />
      )}
    </Styled.Main>
  )
}

VesselForecast.propTypes = {}

export default VesselForecast